import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { login as _login, logout as _logout, getInfo as _getInfo, refreshToken as _refreshToken } from '@/api/user';
import { fetchRoleAuthList } from '@/api/role';
import { getToken, setToken, removeToken, setExpire } from '@/utils/auth';
import { resetRouter } from '@/router';
import Cookies from 'js-cookie';
import { fetchCorporationBalanceList } from '@/api/balance';
import { checkRole } from '@/utils/permission'; // 权限判断函数
var state = {
  token: getToken(),
  name: '',
  roles: [],
  corporation: {},
  corporationID: 0,
  corporationName: '',
  balance: 0,
  expire: Number(Cookies.get('expire') || 0),
  user: {},
  roleAuthList: {}
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, _ref) {
    var token = _ref.token,
      expire = _ref.expire;
    state.token = token;
    setToken(token, expire);
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_ROLE: function SET_ROLE(state, role) {
    state.roles = role;
  },
  SET_CORPORATION_ID: function SET_CORPORATION_ID(state, id) {
    state.corporationID = id;
  },
  SET_CORPORATION: function SET_CORPORATION(state, corporation) {
    state.corporation = corporation;
  },
  SET_CORPORATION_NAME: function SET_CORPORATION_NAME(state, cpname) {
    state.corporationName = cpname;
  },
  SET_EXPIRE: function SET_EXPIRE(state, data) {
    state.expire = data;
    setExpire(data, new Date(setExpire));
  },
  SET_USER: function SET_USER(state, data) {
    state.user = data;
  },
  SET_ROLE_AUTH_LIST: function SET_ROLE_AUTH_LIST(state, data) {
    state.roleAuthList = data;
  }
};
var actions = {
  // user login
  login: function login(_ref2, data) {
    var commit = _ref2.commit;
    var _data$userInfo = data.userInfo,
      email = _data$userInfo.email,
      password = _data$userInfo.password;
    return new _Promise(function (resolve, reject) {
      _login({
        captcha: data.query,
        email: email.trim(),
        password: password
      }).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', {
          token: data.token,
          expire: data.expire
        });
        commit('SET_EXPIRE', new Date(data.expire).getTime());
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3, data) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new _Promise(function (resolve, reject) {
      _getInfo(data || state.token).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
          var data, username, _yield$fetchRoleAuthL, _data, _t;
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                data = response.data; // data['roles'] = ['system_user', 'administrator']
                if (!data) {
                  reject('Verification failed, please Login again.');
                }
                data['roles'] = data.role.reduce(function (acc, cur) {
                  acc.push(cur.alias);
                  return acc;
                }, []);
                username = data.username; // data['roles'] = [role]
                commit('SET_USER', data);
                commit('SET_NAME', username);
                commit('SET_CORPORATION_NAME', data.corporation.name);
                commit('SET_CORPORATION_ID', data.corporation_id);
                commit('SET_CORPORATION', data.corporation);
                commit('SET_ROLE', data.roles);
                fetchCorporationBalanceList(checkRole('administrator') ? 0 : data.corporation_id).then(function (resp) {
                  if (resp.data && resp.data.length > 0) {
                    state.balance = resp.data[0].balance / 100;
                  }
                });
                _context.prev = 1;
                _context.next = 2;
                return fetchRoleAuthList();
              case 2:
                _yield$fetchRoleAuthL = _context.sent;
                _data = _yield$fetchRoleAuthL.data;
                commit('SET_ROLE_AUTH_LIST', _data);
                _context.next = 4;
                break;
              case 3:
                _context.prev = 3;
                _t = _context["catch"](1);
                console.error(_t);
                resolve(_t);
              case 4:
                resolve(data);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 3]]);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (error) {
        commit('SET_TOKEN', '');
        commit('SET_EXPIRE', 0);
        state.roles = [];
        removeToken();
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new _Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_EXPIRE', 0);
        state.roles = [];
        removeToken();
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new _Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_EXPIRE', 0);
      state.roles = [];
      removeToken();
      resolve();
    });
  },
  refreshToken: function refreshToken(_ref7) {
    var commit = _ref7.commit;
    return new _Promise(function (resolve, reject) {
      _refreshToken().then(function (response) {
        var _response$data, _response$data2, _response$data3;
        commit('SET_TOKEN', {
          token: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.token,
          expire: response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.expire_at
        });
        commit('SET_EXPIRE', new Date(response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.expire_at).getTime());
        resolve(response);
      }).catch(function (data) {
        commit('SET_TOKEN', '');
        commit('SET_EXPIRE', 0);
        removeToken();
        reject(_objectSpread({}, data));
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};